import Big from "big.js"
import * as z from "zod"

import { createEntityFor } from "@axtesys/react-tools"

import { ReducedArticleKeyFragment } from "../api/graphql/types"
import { bigToEuros, Euros, eurosToBig } from "../lib/Money"
import { ArticleId } from "./Article"

export type ArticleKeyId = string

export type ArticleKeyContent = {
  articleKeyId: ArticleKeyId
  articleId: ArticleId
  lineOne: string
  color: string
  articlePrice: Euros
  orderIndex: number

  lineTwo?: string
}

export type ArticleKeyData = Pick<
  ArticleKeyContent,
  "color" | "lineOne" | "lineTwo" | "articleId"
>

export type ArticleKeyDataWithId = ArticleKeyData &
  Pick<ArticleKeyContent, "articleKeyId" | "articlePrice">

export type ReducedArticleKeyRecord = Record<
  ArticleKeyId,
  ReducedArticleKeyFragment
>

export const ArticleKeyContentEntity = createEntityFor<ArticleKeyContent>()
  .withSchema(
    z.object({
      articleKeyId: z.string(),
      articleId: z.string(),
      lineOne: z.string(),
      color: z.string(),
      articlePrice: z.string(),
      orderIndex: z.number(),
      lineTwo: z.ostring(),
    }),
  )
  .serialize(data => ({
    ...data,
    articlePrice: eurosToBig(data.articlePrice).toString(),
  }))
  .deserialize(json => ({
    ...json,
    articlePrice: bigToEuros(Big(json.articlePrice)),
  }))
